import { render, staticRenderFns } from "./DashTapinGoal.vue?vue&type=template&id=cdeee514&scoped=true"
import script from "./DashTapinGoal.vue?vue&type=script&lang=js"
export * from "./DashTapinGoal.vue?vue&type=script&lang=js"
import style0 from "./DashTapinGoal.vue?vue&type=style&index=0&id=cdeee514&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdeee514",
  null
  
)

export default component.exports